import { render, staticRenderFns } from "./navbarSidebar.vue?vue&type=template&id=157126eb&"
import script from "./navbarSidebar.vue?vue&type=script&lang=js&"
export * from "./navbarSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports